import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {CommonModal} from 'components/common';
import {SecondaryNavigation} from 'components/Navigation';
import InvitationTable from './InvitationTable';
import InvitationCreation from './InvitationCreation';
import InvitationUpdate from './InvitationUpdate';
import {deleteInvitation, resendInvitation} from 'api';
import {
  fetchInvitations,
  setCurrentInvitationPage,
  setCurrentInvitation,
  clearInvitationsAfterPage,
} from 'actions/invitations';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';
import swal from 'sweetalert2';

const emailSentMessage = () => {
  swal({
    title: 'Success!',
    text: 'Thank you, an email has been sent to the new user so they can activate their account',
    type: 'success',
  });
};

class InvitationList extends React.Component {
  static propTypes = {
    invitationPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      createModalShown: false,
      updateModalShown: false,
      refreshTableKey: 0,
      currentInvitation: null,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCreationSuccess = this.handleCreationSuccess.bind(this);
    this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    this.deleteInvitation = this.deleteInvitation.bind(this);
    this.resendInvitation = this.resendInvitation.bind(this);
  }

  showModal(type, currentInvitation) {
    this.setState({
      [`${type}ModalShown`]: true,
      currentInvitation,
    });
  }

  closeModal(type) {
    this.setState({
      [`${type}ModalShown`]: false,
      currentInvitation: null,
    });
  }

  handleCreationSuccess() {
    this.setState((prevState) => ({
      createModalShown: false,
      refreshTableKey: prevState.refreshTableKey + 1,
    }));
    emailSentMessage();
  }

  handleUpdateSuccess() {
    this.setState((prevState) => ({
      updateModalShown: false,
      refreshTableKey: prevState.refreshTableKey + 1,
      currentInvitation: null,
    }));
    emailSentMessage();
  }

  deleteInvitation(record) {
    const {addFlashMessage, formatErrors} = this.props;
    deleteInvitation(record.id)
      .then(() => {
        this.setState((prevState) => ({
          refreshTableKey: prevState.refreshTableKey + 1,
        }));
        addFlashMessage('The invitation has been successfully deleted!', 'success');
      })
      .catch((err) => formatErrors(err));
  }

  resendInvitation(record) {
    const {addFlashMessage, formatErrors} = this.props;
    addFlashMessage('Resending...', 'success');
    resendInvitation(record.id)
      .then(() => {
        addFlashMessage('Invitation email resent successfully!', 'success');
      })
      .catch((err) => formatErrors(err));
  }

  render() {
    const {createModalShown, updateModalShown, refreshTableKey, currentInvitation} = this.state;
    const {
      activeSchool,
      invitationPages,
      fetchInvitations,
      setCurrentInvitationPage,
      setCurrentInvitation,
      clearInvitationsAfterPage,
    } = this.props;
    const schoolId = activeSchool ? activeSchool.id : null;
    return (
      <div>
        <CommonModal title="Create New Invitation" onClose={() => this.closeModal('create')} show={createModalShown}>
          <InvitationCreation schoolId={schoolId} onSubmitSuccess={this.handleCreationSuccess} />
        </CommonModal>
        <CommonModal title="Edit Invitation" onClose={() => this.closeModal('update')} show={updateModalShown}>
          <InvitationUpdate
            schoolId={schoolId}
            invitation={currentInvitation}
            onSubmitSuccess={this.handleUpdateSuccess}
          />
        </CommonModal>
        <SecondaryNavigation
          tabs={[
            {url: '/users', label: 'Users', isActive: false},
            {url: '/users/invitations', label: 'Invitations', isActive: true},
            // {url: '/users/parent-student-association', label: 'Link Parent and Student', isActive: false},
          ]}
        />
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">Pending Invitations</div>
              <Button
                variant="contained"
                color="primary"
                className="pull-right"
                onClick={() => this.showModal('create')}
              >
                Create Invitation
              </Button>
            </h3>
            <InvitationTable
              {...{
                refreshTableKey,
                recordPages: invitationPages,
                fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                  fetchInvitations(q, page, perPage, sortOpts, {...extraFilters, summary: true, status: 'pending'}),
                setCurrentRecordPage: setCurrentInvitationPage,
                setCurrentRecord: setCurrentInvitation,
                clearRecordsAfterPage: clearInvitationsAfterPage,
                showUpdateModal: (record) => this.showModal('update', record),
                onDeleteActionClick: this.deleteInvitation,
                resendInvitation: this.resendInvitation,
              }}
            />
          </Panel>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {account, invitations} = state;
  const activeSchool = account.getIn(['user', 'activeSchool']);
  return {
    activeSchool: activeSchool ? activeSchool.toJS() : null,
    invitationPages: invitations.get('invitationPages').toJS(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  fetchInvitations: (...args) => dispatch(fetchInvitations(...args)),
  setCurrentInvitationPage: (...args) => dispatch(setCurrentInvitationPage(...args)),
  setCurrentInvitation: (...args) => dispatch(setCurrentInvitation(...args)),
  clearInvitationsAfterPage: (...args) => dispatch(clearInvitationsAfterPage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvitationList);
